import { render, staticRenderFns } from "./OrganisationSourceIcon.vue?vue&type=template&id=5864b244&"
import script from "./OrganisationSourceIcon.vue?vue&type=script&lang=js&"
export * from "./OrganisationSourceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports